module.exports = __webpack_public_path__ + "static/media/burbuja_fondo.9a65f9f2.png";